import Vue from 'vue'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'

var updateLocale = require('dayjs/plugin/updateLocale')
dayjs.extend(updateLocale)
require('dayjs/locale/es')
dayjs.locale('es')
dayjs.extend(relativeTime)
Object.defineProperties(Vue.prototype, {
  $date: {
      get () {
          return dayjs
      },
  },
})

/* En caso de que algun dia haga falta
dayjs.updateLocale('es', {
  relativeTime: {
    future: 'in %s',
    past: '%s hace',
    s: 'hace unos segundos',
    m: 'hace un minuto',
    mm: '%d minutos',
    h: 'una hora',
    hh: '%d horas',
    d: 'a dia',
    dd: '%d dias',
    M: 'a mes',
    MM: '%d meses',
    y: 'a año',
    yy: '%d años',
  },
})
*/
